import { render, staticRenderFns } from "./breed-table-component-list.vue?vue&type=template&id=6440b098&scoped=true&lang=pug"
import script from "./breed-table-component-list.js?vue&type=script&lang=js&external"
export * from "./breed-table-component-list.js?vue&type=script&lang=js&external"
import style0 from "./breed-table-component-list.vue?vue&type=style&index=0&id=6440b098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6440b098",
  null
  
)

export default component.exports